import { Component, EventEmitter, Input, Output } from "@angular/core";

import { FoundMedicationIncidentDetail } from "app/shared/types";
import { SharedModule } from "../../../../shared/shared.module";

@Component({
	selector: "ic-found-medication-incident-details-list",
	templateUrl: "./medication-incident-details-list.component.html",
	styleUrls: ["medication-incident-details-list.component.scss"],
	imports: [SharedModule],
})
export class MedicationIncidentDetailsListComponent {
	@Output() deleteDetail = new EventEmitter<FoundMedicationIncidentDetail>();
	// @ts-expect-error TS2564
	@Input() details: FoundMedicationIncidentDetail[];
	@Input() touched = false;

	protected onDelete(item: FoundMedicationIncidentDetail) {
		this.deleteDetail.emit(item);
	}
}
